import { action } from '@storybook/addon-actions';
import type { Meta, StoryObj } from '@storybook/react';

import { SkipButton } from './SkipButton';

const meta: Meta<typeof SkipButton> = {
  title: 'parts/link button/SkipButton',
  component: SkipButton,
  args: { onClick: action('clicked') },
  tags: ['autodocs'],
};

export default meta;

type Story = StoryObj<typeof SkipButton>;

export const Basic: Story = {
  args: {
    onClick: action('clicked'),
  },
};
